/// <amd-module name="VSSUI/Components/PersonaCard/PersonaCardIdentityUtils" />
import { IIdentity } from "./PersonaCard.Props";

/** @deprecated */
export function isCompleteIdentity(identity: IIdentity, checkMail?: boolean) {
    if (!identity) {
        return false;
    }

    if (isAadUser(identity) || isAdUser(identity)) {
        return !!(
            (checkMail && identity.mail) ||
            identity.mailNickname ||
            identity.jobTitle ||
            identity.department ||
            identity.physicalDeliveryOfficeName ||
            identity.manager ||
            identity.surname ||
            identity.telephoneNumber
        );
    } else if (isVsdUser(identity)) {
        return !!identity.signInAddress;
    } else if (isWmdUser(identity)) {
        return !!(identity.scopeName || identity.signInAddress);
    }

    return false;
}

/** @deprecated */
export function isAadUser(identity: IIdentity): boolean {
    return identity && identity.originDirectory && identity.originDirectory.trim().toLowerCase() === "aad";
}
/** @deprecated */
export function isAdUser(identity: IIdentity): boolean {
    return identity && identity.originDirectory && identity.originDirectory.trim().toLowerCase() === "ad";
}
/** @deprecated */
export function isVsdUser(identity: IIdentity): boolean {
    return identity && identity.originDirectory && identity.originDirectory.trim().toLowerCase() === "vsd";
}
/** @deprecated */
export function isWmdUser(identity: IIdentity): boolean {
    return identity && identity.originDirectory && identity.originDirectory.trim().toLowerCase() === "wmd";
}
